export class Domain {

    private domains: Set<string> = new Set();

    constructor(_domains: Set<string>) {        
        Array.from(_domains).map((domain) => {            
            const domainName = domain[0];
            
            return this.domains.add(domainName);
        });
    }

    getAllDomains(): Set<string> {
        return this.domains;
    }
 
}